module.exports = __webpack_public_path__ + "static/assets/58f076fce6f7e6d43f0cd275e20a6641.png";